import React, { useEffect, useState } from 'react';

// Types each phrase, pauses, deletes it, moves to the next. With reduced
// motion it simply shows the first phrase.
const Typewriter = ({ phrases, className = '' }) => {
  const [i, setI] = useState(0);
  const [len, setLen] = useState(0);
  const [deleting, setDeleting] = useState(false);
  const still = typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

  useEffect(() => {
    if (still) return undefined;
    const full = phrases[i];
    let delay = deleting ? 35 : 70;
    if (!deleting && len === full.length) delay = 1800;
    if (deleting && len === 0) delay = 300;
    const id = setTimeout(() => {
      if (!deleting && len === full.length) setDeleting(true);
      else if (deleting && len === 0) { setDeleting(false); setI((i + 1) % phrases.length); }
      else setLen(len + (deleting ? -1 : 1));
    }, delay);
    return () => clearTimeout(id);
  }, [i, len, deleting, phrases, still]);

  const text = still ? phrases[0] : phrases[i].slice(0, len);
  return (
    <span className={className} aria-label={phrases[0]}>
      <span aria-hidden="true">{text}</span><span className="type-caret" aria-hidden="true" />
    </span>
  );
};

export default Typewriter;
